import { Component } from '@angular/core';

@Component({
    selector: 'ga-bottom-navigation',
    template: '<ng-content></ng-content>',
    styleUrls: ['./bottom-navigation.component.scss']
})
export class GaBottomNavigationComponent { }
